import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './context/ProtectedRoute';
import { LoginPage } from './auth/LoginPage';
import { SignupPage } from './auth/SignUp';
import { FamilyPage } from './pages/FamilyPage';
import StorytimeApp from './app_landing/StoryTimeApp';
import { ParentDashboardPage } from './pages/ParentDashboardPage';
import { GrandparentDashboardPage } from './pages/GrandParentDashboardPage';
import RecordingPage from './pages/RecordingPage';
import RecordingDetailPage from './pages/GrandParentRecordingDetail';
import BookPreviewPage from './pages/BookReviewPage';
import { KidStoriesPage } from './pages/KidsPage';
import { AdminBookUploadPage } from './admin/AdminBookUpload';
import PersonalBookRecordingPage from './pages/PersonalBookRecordingPage';
import { ManageProfilePage } from './pages/Profile';
import { SubscriptionPage } from './pages/SubscriptionPage';
import { ForgotPasswordPage } from './auth/ForgotPassword';
import { ResetPasswordPage } from './auth/ResetPassword';
import PersonalBookRecordingWrapper from './components/PersonalBookRecordingWrapper';
import PersonalRecordingDetailPage from './pages/PersonalRecordingDetailsPage';
import CugPage from './cug-section/CugPage';
import PolyPage from './poly-section/PolyPage';
import BugReportButton from './items/ReportBug';
function App() {

  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/family" element={<FamilyPage />} />


        {/* Protected routes */}
        <Route
          path="/parent-dashboard"
          element={
            <ProtectedRoute requireRole="parent">
              <ParentDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/grandparent-dashboard"
          element={
            <ProtectedRoute requireRole="grandparent">
              <GrandparentDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route path="/book" element={<BookPreviewPage />} />
        <Route path="/cug" element={<CugPage />} />
        <Route path="/poly" element={<PolyPage />} />
        <Route path="/book/:bookId" element={<BookPreviewPage />} />
        <Route path="/record" element={<RecordingPage />} />
        <Route path="/record-personal" element={<PersonalBookRecordingWrapper />} />

        <Route path="/recording/:recordingId" element={<RecordingDetailPage />} />
        <Route path="/subscription" element={<SubscriptionPage />} />


        <Route
          path="/admin/books"
          element={
            <AdminBookUploadPage />
          }
        />

        {/* Add more protected routes as needed */}

        {/* Default redirect */}
        <Route path="/" element={<StorytimeApp />} />
        <Route path="/profile" element={<ManageProfilePage />} />
        <Route path="/child/:kidId" element={<KidStoriesPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/personal-recording/:recordingId" element={<PersonalRecordingDetailPage />} />

      </Routes>
      <BugReportButton />

    </AuthProvider>
  );
}

export default App;